<cm-test-container [testCases]="testCases"> <iframe style="width: 100%; height: 100%" frameborder="0" #iframe></iframe></cm-test-container>
